// extracted by mini-css-extract-plugin
module.exports = {"widget":"styles_widget__x5SSA","crossButton":"styles_crossButton__oMw_M","logo":"styles_logo__P0ogB","list":"styles_list__JeLr6","action":"styles_action__5RsaL"};